var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"chart-pot-image\" ng-show=\"pot.value != 'En attente' &amp;&amp; pot.value != '0,00'\"\u003E\u003Cimg src=\"\u002Fassets\u002Fimg\u002Fcochon.png\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/directives/chart-pot-image/view.jade
// module id = 716
// module chunks = 1